<template>
  <button class="btn obituary donation-cta" @click.prevent="trigger()">
    <svg viewBox="0 0 576 512">
      <use href="#hand-holding-heart" />
    </svg>
    <span v-text="text" />
  </button>
</template>

<script>
import { mapActions } from 'vuex';
import { DONATION_INITIAL } from '../../createCommentStepsHelper';

export default {
  name: 'DonationCta',

  data() {
    return {
      text: lavendlaObituary.common.donate,
    };
  },

  methods: {
    ...mapActions('createComment', ['toggleModal']),

    trigger() {
      this.toggleModal(DONATION_INITIAL);
    },
  },
};
</script>
